import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=fcc097c0&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"
import style0 from "./MainSection.vue?vue&type=style&index=0&id=fcc097c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc097c0",
  null
  
)

export default component.exports